import { render, staticRenderFns } from "./ProductFlag.vue?vue&type=template&id=78cb82c0"
import script from "./ProductFlag.vue?vue&type=script&lang=ts"
export * from "./ProductFlag.vue?vue&type=script&lang=ts"
import style0 from "./ProductFlag.vue?vue&type=style&index=0&id=78cb82c0&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports